export default __webpack_public_path__ + "static/media/typeShip.313f634b.svg";